module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.674f50d2.8b43027.eot";